const extAssessment = {
  err_hackerrank_duplicate_invite: {
    message: 'Candidate has received this assessment already',
  },
  err_hackerrank_not_invited: {
    message: 'Unable to send the assessment to the candidate. Try again later.',
  },
  err_not_hackerrank_assessment: {
    message:
      'Assessment deleted on HackerRank. Try again with a different one.',
  },
  err_hackerrank_cancel_failed: {
    message: 'Unable to cancel the assessment. Try again later.',
  },
  err_hackerrank_candidate_not_found: {
    message: 'HackerRank candidate not found.',
  },
  err_hackerrank_candidate_already_taken_test: {
    message: 'Candidate has taken this assessment already',
  },
  err_hackerrank_invite_failed: {
    message: 'Something went wrong. Try again later.',
  },
  err_candidate_email_not_found: {
    message: 'Candidate does not have an email address. Add one and try again.',
  },
  hackerrank_account_not_connected: {
    message: 'HackerRank account not connected. Please connect your account.',
  },
  err_hackerrank_account_not_activated: {
    message: 'HackerRank account not activated. Please activate your account.',
  },
  err_hackerrank_template_invalid: {
    message: 'Invalid HackerRank template. Try selecting another one.',
  },

  //hackerearth
  err_hackerearth_api_error: {
    message:
      'HackerEarth API error. Please check your credentials and try again.',
  },
  err_client_id_or_client_secret_not_present: {
    message: 'Client ID and Client Secret are required.',
  },
  err_hackerearth_candidate_already_taken_test: {
    message:
      'Unable to send assessment. This candidate has taken this assessment already',
  },
  err_report_pdf_url_not_found: {
    message: 'HackerEarth report is unavailable. Try again later.',
  },
  err_hackerearth_insufficient_credits: {
    message:
      'Unable to send assessment. Insufficient credits in your HackerEarth account.',
  },
  err_hackerearth_candidate_already_invited: {
    message:
      'Unable to send assessment. This candidate has been invited to this test already.',
  },
  err_hackerearth_invite_failed: {
    message: 'Unable to send assessment. Try again later.',
  },
  err_unauthorized_hackerearth: {
    message: 'Hackerearth account not connected. Please connect your account.',
  },
  err_hackerearth_test_access_disabled: {
    message:
      'This assessment is disabled on HackerEarth. Please enable it or select a different one.',
  },
  err_hackerearth_invalid_email: {
    message: 'Invalid email address. Please enter a valid email address.',
  },
  err_hackerearth_authentication_failed: {
    message:
      'HackerEarth re-authentication by an admin required for this action.',
  },
  err_hackerearth_invalid_test_id: {
    message: 'Invalid test ID. Please enter a valid test ID.',
  },
  err_hackerearth_test_ended: {
    message: 'This assessment has ended. Please select a different one.',
  },

  //criteriacorp
  err_criteria_corp_invite_failed: {
    message: 'Unable to send assessment. Try again later.',
  },
  err_unauthorized_criteriacorp: {
    message: 'Criteriacorp account not connected. Please connect your account.',
  },
  err_no_active_cc_integration: {
    message: 'Criteriacorp account not connected. Please connect your account.',
  },
  err_criteriacorp_integration_missing: {
    message: 'Criteriacorp account not connected. Please connect your account.',
  },

  //hireflix
  err_ext_test_id_missing: {
    message: 'Missing Hireflix test ID. Please select a test.',
  },
  err_ats_application_ids_missing: {
    message: 'No applications selected. Please select at least one candidate.',
  },
  err_ats_job_stage_not_found: {
    message: 'Invalid job stage selected.',
  },
  err_no_applications_passed: {
    message: 'No valid applications found to process.',
  },
  err_hireflix_integration_missing: {
    message:
      'Hireflix integration not connected. Please enable it in Settings.',
  },
  err_hireflix_candidate_email_not_found: {
    message: 'Candidate email address is missing.',
  },
  err_hireflix_position_missing: {
    message: 'Test ID is missing. Please select a Hireflix test.',
  },
  err_hireflix_invite_failed: {
    message: 'Failed to send Hireflix invite. Please try again.',
  },
  err_contact_email_missing: {
    message: 'Application missing contact information.',
  },
  err_test_id_missing: {
    message: 'Hireflix test ID is required.',
  },
  err_no_active_hf_integration: {
    message: 'No active Hireflix integration found.',
  },
  err_api_key_not_present: {
    message: 'Hireflix API key is missing.',
  },
  err_webhook_secret_not_present: {
    message: 'Webhook secret is missing.',
  },
  err_authentication_failed: {
    message: 'Failed to authenticate with Hireflix. Please check your API key.',
  },
  err_hireflix_candidate_already_invited: {
    message: 'Candidate has already been invited for this position.',
  },
  err_hireflix_test_id_missing: {
    message: 'Test ID required to send invite.',
  },
  err_hireflix_invite_validation_failed: {
    message: 'Failed to send Hireflix invite. Please check candidate email.',
  },

  err_codeinterview_integration_missing: {
    message:
      'CodeInterview integration not connected. Please enable it in Settings.',
  },
  err_codeinterview_candidate_email_not_found: {
    message: 'Candidate email address is missing.',
  },
  err_codeinterview_invite_failed: {
    message: 'Failed to send CodeInterview invite. Please try again.',
  },
  err_codeinterview_report_not_supported: {
    message: 'Report generation is not supported for CodeInterview.',
  },
  err_no_active_codeinterview_integration: {
    message: 'No active CodeInterview integration found.',
  },
  err_codeinterview_unsupported_email: {
    message: 'This candidate does not have a valid email address.',
  },
};

export default extAssessment;
